import { createRequestTypes, fetchActionFactory } from "../policies/actions";
import { FETCH_AUDIT_LOG_ENTITIES,FETCH_AUDIT_LOGS } from "./constants";

const AUDIT_LOGS = createRequestTypes(FETCH_AUDIT_LOGS);
const AUDIT_LOG_ENTITIES = createRequestTypes(FETCH_AUDIT_LOG_ENTITIES);

/* audit logs */
export const auditLogs = fetchActionFactory(AUDIT_LOGS);

/* audit log entities */
export const auditLogEntities = fetchActionFactory(AUDIT_LOG_ENTITIES);

export default { auditLogs };
